import React from 'react';
import './PageIndicator.scss';
const PageIndicator = ({
  pages,
  current,
  selectedColor
}) => /*#__PURE__*/React.createElement("div", {
  className: "PageIndicator"
}, pages.map((page, index) => /*#__PURE__*/React.createElement("div", {
  key: index,
  className: `indicator ${current === index ? 'current' : ''}`,
  style: {
    '--accent-color': selectedColor
  }
})));
export default PageIndicator;